import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TAGS_CONTAINER: `${cleanedFilename(__filename)}-tags-container`,
};
